import { useModalContext } from '@fourthwall/components';
import React, { useEffect, useMemo, useState } from 'react';
import { useCurrentShopQuery } from '../../../../hooks/useCurrentShopQuery';
import { useShopPaymentMethods } from '../../hooks/useShopPaymentMethods';
import { useSetShopDefaultPaymentMethodMutation } from '../../queries/useSetShopDefaultPaymentMethodMutation';
import { getErrorBanner } from '../../utils/getErrorBanner';
import { AddPaymentMethodModal } from '../AddPaymentMethodModal';
import { SelectPaymentMethodView } from './SelectPaymentMethodView';
export const SelectPaymentMethodContainer = ({ submitLabel = 'Confirm', withChargeLimit = true, onSuccess, onAddPaymentMethodClose, children, }) => {
    const { open } = useModalContext();
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(undefined);
    const { defaultPaymentMethod, shopPaymentMethods, isLoadingShopPaymentMethods, invalidateShopPaymentMethods, } = useShopPaymentMethods();
    const selectPaymentMethodViewType = useMemo(() => {
        if (isLoadingShopPaymentMethods) {
            return 'LOADING';
        }
        if (!shopPaymentMethods || shopPaymentMethods.length === 0) {
            return 'NO_PAYMENT_METHODS';
        }
        return 'HAS_PAYMENT_METHODS';
    }, [isLoadingShopPaymentMethods, shopPaymentMethods]);
    const { invalidateCurrentShopQuery } = useCurrentShopQuery();
    const { setShopDefaultPaymentMethodMutation } = useSetShopDefaultPaymentMethodMutation();
    const shopPaymentMethodsProps = useMemo(() => shopPaymentMethods?.map((paymentMethod) => ({
        ...paymentMethod,
        selected: selectedPaymentMethodId === paymentMethod.id,
        onClick: () => setSelectedPaymentMethodId(paymentMethod.id),
    })), [shopPaymentMethods, selectedPaymentMethodId]);
    useEffect(() => {
        if (defaultPaymentMethod && !defaultPaymentMethod.invalid) {
            setSelectedPaymentMethodId(defaultPaymentMethod.id);
        }
    }, [defaultPaymentMethod]);
    const handleSuccess = () => {
        onSuccess();
        invalidateShopPaymentMethods();
        invalidateCurrentShopQuery();
    };
    const handleSubmit = () => {
        if (!selectedPaymentMethodId) {
            return;
        }
        if (selectedPaymentMethodId === defaultPaymentMethod?.id) {
            return handleSuccess();
        }
        setShopDefaultPaymentMethodMutation.mutate([selectedPaymentMethodId], {
            onSuccess: handleSuccess,
        });
    };
    const handleAddPaymentMethod = () => {
        open(AddPaymentMethodModal, {
            title: 'Add a new payment method',
            withChargeLimit,
            onSuccess: () => {
                onAddPaymentMethodClose?.();
                invalidateShopPaymentMethods();
                invalidateCurrentShopQuery();
            },
            onCancel: () => {
                onAddPaymentMethodClose?.();
            },
        });
    };
    return (React.createElement(SelectPaymentMethodView, { viewType: selectPaymentMethodViewType, submitLabel: submitLabel, withChargeLimit: withChargeLimit, paymentMethodsProps: shopPaymentMethodsProps, errorBanner: getErrorBanner(shopPaymentMethodsProps), isSubmitting: setShopDefaultPaymentMethodMutation.isLoading, isLoading: isLoadingShopPaymentMethods, isDisabled: !selectedPaymentMethodId || selectPaymentMethodViewType === 'LOADING', onAddPaymentMethod: handleAddPaymentMethod, onSubmit: handleSubmit, onSuccess: handleSuccess }, children));
};
